export default "__VITE_ASSET__CCdqrRIh__"